import React from 'react'
import { Button } from 'react-bootstrap'
import CONFIG from '../../../../config/config'
import ReactGA from 'react-ga'

import './subscriptionComponent.scss'

class SubscriptionComponent extends React.Component {
    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'Subscription Page' });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        const url = CONFIG.storageURL;
        return <div className="subscription-component">
            <div className="buttons">
                <Button className="docs" target="_blank" href={url}>
                    Docs {this.url}
                </Button>
            </div>
        </div>
    }
}

/*SubscriptionComponent.propTypes = {
    //version: PropTypes.string.isRequired,
    archives: PropTypes.object.isRequired,
};
*/
export default SubscriptionComponent



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/Subscription/SubscriptionComponent.js